import { HttpContextToken } from '@angular/common/http';

/** The owning workflow handles authentication failure without replaying a mutation. */
export const LOCAL_AUTH_FAILURE = new HttpContextToken<boolean>(() => false);
